import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private loadingCount = 0;
  private timeoutIds: Set<number> = new Set();

  constructor() {
    // Global debug function for easy access
    if (typeof window !== 'undefined') {
      (window as any).resetLoader = () => this.reset();
      (window as any).getLoaderCount = () => this.loadingCount;
      (window as any).getLoaderState = () => this.loadingSubject.value;
    }
  }

  get loading$(): Observable<boolean> {
    return this.loadingSubject.asObservable();
  }

  startLoading(): void {
    this.loadingCount++;
    
    if (this.loadingCount === 1) {
      this.loadingSubject.next(true);
      
      // Timeout fallback - automatically hide loader after 30 seconds
      const timeoutId = window.setTimeout(() => {
        this.reset();
      }, 30000);
      this.timeoutIds.add(timeoutId);
    }
  }

  stopLoading(): void {
    
    if (this.loadingCount > 0) {
      this.loadingCount--;
      
      if (this.loadingCount === 0) {
        this.loadingSubject.next(false);
        this.clearTimeouts();
      }
    }
  }

  reset(): void {
    this.loadingCount = 0;
    this.loadingSubject.next(false);
    this.clearTimeouts();
  }

  private clearTimeouts(): void {
    this.timeoutIds.forEach(id => clearTimeout(id));
    this.timeoutIds.clear();
  }


  // getDebugInfo() {
  //   return {
  //     count: this.loadingCount,
  //     isLoading: this.loadingSubject.value,
  //     timeouts: this.timeoutIds.size
  //   };
  // }
} 